import apiClient from "../api/apiClient";
import ENDPOINTS from "../api/endPoint";

export const fetchBusinessUnit = () => {
  return apiClient(ENDPOINTS.BUSINESSUNIT, { method: "GET" });
};

export const createBusinessUnit = (businessunitdata) => {
  return apiClient(
    ENDPOINTS.BUSINESSUNIT,
    { method: "POST", body: businessunitdata },
    {
      headers: { "Content-Type": "application/json" },
    }
  );
};

export const updateBusinessUnit = (id, businessunitdata) => {
  return apiClient(
    `${ENDPOINTS.BUSINESSUNIT}/${id}`,
    { method: "PUT", body: businessunitdata },
    {
      headers: { "Content-Type": "application/json" },
    }
  );
};

export const deleteBusinessUnit = (id) => {
  return apiClient(`${ENDPOINTS.BUSINESSUNIT}/${id}`, {
    method: "DELETE",
  });
};
